import scrollViewport from '../utils/scroll-viewport';

var caseLength = window.caseLenght || 0;

scrollViewport('.screen', function($screen) {
    $screen.addClass('active').removeClass('disabled-animated');
}, {
    delayDistance:200,
    onLeave: function($screen) {
        $screen.removeClass('active');
    }
});

var looped = true;
var mySwiper;
$(document).ready(function() {
  if ($("#length").attr("value") <= 4) {
    looped = false;
    $(".pagination").hide();
  }
  initSwiper();
});

function initSwiper() {
    mySwiper = new Swiper('.swiper-container', {
     // autoplay : 3000,
     pagination: '.pagination',
     paginationClickable: true,
     slidesPerView: 1,
     loop: looped
   })
}



// WEBPACK FOOTER //
// ./src/js/pmo.js